import styled from "styled-components"
import Icon from "../../../components/Icon/icon"

const AdditionalInfos = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`
const AdressTitle = styled.h1`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const Separator = styled.hr`
  &::after {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const AdressPlaceIcon = styled(Icon)`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const AdressPlaceTitle = styled.p`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const AdressFooterContainer = styled.div`
  color: ${(props) => props.theme.a_color_gradients.dark};
`

export {
  AdditionalInfos,
  AdressTitle,
  Separator,
  AdressPlaceIcon,
  AdressPlaceTitle,
  AdressFooterContainer,
}
